import { ENV } from './env';

const KEY = 'ia:inApp';

/**
 * The mobile app opens web pages with `?app=1` (in-app browser). Remembered for the browser session, because
 * navigation inside the web app drops the parameter. Apple 3.1.1 / Go-live S6: no web purchase from the app.
 */
export function captureInAppFlag(search: string = typeof window === 'undefined' ? '' : window.location.search) {
  try {
    if (new URLSearchParams(search).get('app') === '1') sessionStorage.setItem(KEY, '1');
  } catch {
    /* storage blocked: the flag only applies to this page view */
  }
}

/** Web opened from the mobile app (this session). */
export function inMobileApp(): boolean {
  try {
    if (sessionStorage.getItem(KEY) === '1') return true;
  } catch {
    /* storage blocked */
  }
  return typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('app') === '1';
}

/**
 * Stripe checkout, subscribe and manage buttons are shown only when Stripe is enabled for this build
 * (VITE_STRIPE_ENABLED, default on) and the page was not opened from the mobile app.
 */
export type PurchaseBlock = 'app' | 'disabled' | null;
export function webPurchaseBlock(): PurchaseBlock {
  if (inMobileApp()) return 'app';
  if (!ENV.stripeEnabled) return 'disabled';
  return null;
}

/**
 * Website URL (legal pages, help) as seen from here: from the mobile app the website gets `?app=1` too, so it
 * hides its header, footer, prices and sign-up links (apps/landing/src/layouts/Base.astro, Apple 3.1.1).
 */
export function siteUrl(url: string): string {
  if (!inMobileApp()) return url;
  const [base = '', hash] = url.split('#');
  return `${base}${base.includes('?') ? '&' : '?'}app=1${hash !== undefined ? `#${hash}` : ''}`;
}
